import {
    array,
    bool,
    func,
    number,
    oneOf,
    oneOfType,
    shape,
    string,
} from "prop-types";
import ClientId from "data/ClientId";

const states = [
    "illegal",
    "warning",
    // "unusual",
    // "missing",
    "ok",
    "unknown",
];

const item = {
    message: string.isRequired,
    state: oneOf(states).isRequired,
    nestedState: oneOf(states).isRequired,
    cid: string.isRequired,
    entityKey: string.isRequired,
    recordId: oneOfType([
        ClientId.propType,
        number,
    ]).isRequired,

    // only for non-leaves
    children: array,

    // only for fields...
    fieldKey: string,
};

export const itemType = shape({
    ...item
});

export const validationTreeItemType = {
    collapsedAll: bool,
    expandedAll: bool,
    ...item,
    onNavToField: func.isRequired,
};



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/validationtree/types.js